module.exports = __webpack_public_path__ + "static/img/development.826deb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/development.png
// module id = x/ys
// module chunks = 1